// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ss-0";